module.exports = __webpack_public_path__ + "static/media/31.6a86fda6.svg";